import { createTheme } from '@mui/material/styles'

declare module './components/AppChat/AppChatChannel/AppChatChannelBadgeTypes' {
	interface AppChatChannelBadgePropsColorOverrides {
		sushi: true
		gold: true
		steelBlue: true
		trueV: true
		camelot: true
		temptress: true
		burntSienna: true
		dark: true
		orange: true
		ocean: true
		oceanDark: true
		porcelain: true
		catskillWhite: true
		brown: true
	}
}

declare module '@mui/material/Chip' {
	interface ChipPropsColorOverrides {
		sushi: true
		gold: true
		steelBlue: true
		trueV: true
		camelot: true
		temptress: true
		burntSienna: true
		dark: true
		orange: true
		ocean: true
		oceanDark: true
		porcelain: true
		catskillWhite: true
		brown: true
	}
}

declare module '@mui/material/Badge' {
	interface BadgePropsColorOverrides {
		sushi: true
		gold: true
		steelBlue: true
		trueV: true
		camelot: true
		temptress: true
		burntSienna: true
		dark: true
		orange: true
		ocean: true
		oceanDark: true
		porcelain: true
		catskillWhite: true
		brown: true
	}
}

declare module '@mui/material/Button' {
	interface ButtonPropsColorOverrides {
		sushi: true
		gold: true
		steelBlue: true
		trueV: true
		camelot: true
		temptress: true
		burntSienna: true
		dark: true
		orange: true
		ocean: true
		oceanDark: true
		porcelain: true
		info: true
		catskillWhite: true
		brown: true
	}

	interface ButtonPropsSizeOverrides {
		customMedium: true
		brown: true
	}
}

declare module '@mui/material/SvgIcon' {
	interface SvgIconPropsColorOverrides {
		sushi: true
		gold: true
		steelBlue: true
		trueV: true
		camelot: true
		temptress: true
		burntSienna: true
		dark: true
		orange: true
		ocean: true
		oceanDark: true
		porcelain: true
		catskillWhite: true
		brown: true
	}
}

declare module '@mui/material/CircularProgress' {
	interface CircularProgressPropsColorOverrides {
		sushi: true
		gold: true
		steelBlue: true
		trueV: true
		camelot: true
		temptress: true
		burntSienna: true
		dark: true
		orange: true
		ocean: true
		oceanDark: true
		porcelain: true
		catskillWhite: true
		brown: true
	}
}
//
// declare module '@mui/material/InputBase' {
// 	interface InputBasePropsColorOverrides {
// 		teal: true
// 	}
// }
// Example to add new palette

declare module '@mui/material/styles' {
	interface PaletteColor {
		300?: string
	}

	interface SimplePaletteColorOptions {
		300?: string
	}

	interface Palette {
		[key: string]: PaletteColor
		sushi: PaletteColor
		gold: PaletteColor
		steelBlue: PaletteColor
		trueV: PaletteColor
		camelot: PaletteColor
		temptress: PaletteColor
		burntSienna: PaletteColor
		dark: PaletteColor
		orange: PaletteColor
		ocean: PaletteColor
		oceanDark: PaletteColor
		porcelain: PaletteColor
		catskillWhite: PaletteColor
		brown: PaletteColor
	}
	interface PaletteOptions {
		sushi: SimplePaletteColorOptions
		gold: SimplePaletteColorOptions
		steelBlue: SimplePaletteColorOptions
		trueV: SimplePaletteColorOptions
		camelot: SimplePaletteColorOptions
		temptress: SimplePaletteColorOptions
		burntSienna: SimplePaletteColorOptions
		dark: SimplePaletteColorOptions
		orange: SimplePaletteColorOptions
		ocean: SimplePaletteColorOptions
		oceanDark: SimplePaletteColorOptions
		porcelain: SimplePaletteColorOptions
		catskillWhite: PaletteColor
		brown: PaletteColor
	}
}

declare module '@mui/material/styles' {
	interface BreakpointOverrides {
		xs: true
		sm: true
		md: true
		lg: true
		lgx: true
		xl: true
		xxl: true
	}
}

const theme = createTheme({
	typography: {
		fontFamily: `Gilroy, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, 'Noto Sans', 'Liberation Sans', sans-serif, 'Apple Color Emoji',
    'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'`,
		h1: {
			fontFamily: 'Gilroy-SemiBold, sans-serif',
		},
		h2: {
			fontFamily: 'Gilroy-SemiBold, sans-serif',
		},
		h3: {
			fontFamily: 'Gilroy-SemiBold, sans-serif',
		},
		h4: {
			fontFamily: 'Gilroy-SemiBold, sans-serif',
			fontSize: '2rem',
		},
		h5: {
			fontFamily: 'Gilroy-SemiBold, sans-serif',
		},
		h6: {
			fontFamily: 'Gilroy-SemiBold, sans-serif',
		},
		subtitle1: {
			fontFamily: 'Gilroy-SemiBold, sans-serif',
			fontSize: '1rem',
			color: '#175664',
		},
		subtitle2: {
			fontFamily: 'Gilroy-SemiBold, sans-serif',
			fontSize: '1.125rem',
			color: '#5b646b',
		},
	},
	breakpoints: {
		values: {
			xs: 0,
			sm: 600,
			md: 900,
			lg: 1280,
			lgx: 1367,
			xl: 1536,
			xxl: 1920,
		},
	},
	palette: {
		primary: {
			light: '#398798',
			300: '#3a6770',
			main: '#175664',
			dark: '#0e4753',
			contrastText: '#ffffff',
		},
		secondary: {
			light: '#f5f6f7',
			main: '#f5f6f7',
			dark: '#e9eef2',
			contrastText: '#175664',
		},
		ocean: {
			light: '#f5f6f7',
			main: '#e9eef2',
			dark: '#deeaed',
			contrastText: '#175664',
		},
		oceanDark: {
			light: '#F7F8F9',
			main: '#deeaed',
			dark: '#d4e1e3',
			contrastText: '#175664',
		},
		error: {
			light: '#fff7f7',
			main: '#b54242',
			dark: '#863030',
		},
		text: {
			primary: '#202130',
			secondary: '#3e3f4c',
		},
		action: {
			disabledBackground: 'rgba(0,0,0,0.05)',
			disabled: '#afafaf',
		},
		info: {
			light: '#5b646b',
			main: '#deeaed',
			dark: '#0e4753',
			contrastText: '#ffffff',
		},
		sushi: {
			light: '#74B43059',
			main: '#74b430',
			dark: '#5e8d27',
			contrastText: '#ffffff',
		},
		gold: {
			light: '#D5AE3359',
			main: '#d5ae33',
			dark: '#b4942c',
			contrastText: '#ffffff',
		},
		orange: {
			light: '#E7B280',
			main: '#ea9e2b',
			dark: '#9a6b20',
			contrastText: '#ffffff',
		},
		steelBlue: {
			light: '#4994B859',
			main: '#4994B8',
			dark: '#3e7f9b',
			contrastText: '#ffffff',
		},
		trueV: {
			light: '#7355D259',
			main: '#7355D2',
			dark: '#5f47ab',
			contrastText: '#ffffff',
		},
		camelot: {
			light: '#852C5C59',
			main: '#852c5c',
			dark: '#672249',
			contrastText: '#ffffff',
		},
		temptress: {
			light: '#4F000159',
			main: '#4F0001',
			dark: '#480000',
			contrastText: '#ffffff',
		},
		burntSienna: {
			light: '#FAC9C4',
			main: '#F16658',
			dark: '#c59e9c',
			contrastText: '#ffffff',
		},
		dark: {
			light: '#424242',
			main: '#272727',
			dark: '#181818',
			contrastText: '#ffffff',
		},
		porcelain: {
			light: '#fafcfc',
			main: '#f7f8f9',
			dark: '#f5f5f6',
			contrastText: '5b646b',
		},
		catskillWhite: {
			light: '#ECF5F7',
			main: '#ECF5F7',
			dark: '#ECF5F7',
			contrastText: '5b646b',
		},
		brown: {
			light: '#3e3f4c',
			main: '#202130',
			dark: '#181925',
			contrastText: '#ffffff',
		},
	},
	shape: {
		borderRadius: 10,
	},
	spacing: (factor: number) => `${0.25 * factor}rem`,
	components: {
		MuiButton: {
			styleOverrides: {
				root: {
					fontFamily: 'Gilroy-SemiBold, sans-serif',
					fontWeight: 600,
					textTransform: 'none',
				},

				sizeLarge: {
					padding: '0.5em 1.25rem',
					fontSize: '1rem',
				},
			},

			variants: [
				{
					props: {
						size: 'customMedium',
					},
					style: {
						padding: '0.6rem 0.875rem',
						fontFamily: 'Gilroy-SemiBold, sans-serif',
						fontSize: '1rem',
						lineHeight: '1.2',
						boxShadow: 'none',
						':hover': {
							boxShadow: 'none',
						},
					},
				},
			],
		},
	},
})

export default theme
